import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { PersonalDataSubForm,Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const NeuwogesStandardSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const NeuwogesStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}